import React, { Component } from "react";
import Grid from "@mui/material/Grid";
import { Breadcrumbs, Typography } from "@mui/material";
import Link from "@mui/material/Link";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";

import CtBtn from "../Components/CustomTool/CtBtn";
import CtDtp from "./CustomTool/CtDtp";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import { withRouter } from "../HOC/withRouter";
import {
  mapSetUserPrivileges_ToProps,
  mapStatetoProps,
} from "../mapRedux/mapReduxProps";
import { get_YMD_from_SYS } from "../SystemUtility/SystemUtility";

class AMCRevise extends Component {
  state = {
    formData: {
      dtpReviseDate: get_YMD_from_SYS(new Date()),
    },
  };

  componentDidMount() {
    document.title = "AMC Revise";
    localStorage.setItem("Heading", "AMC Revise");
    this.props.verifyUserID(this.getInfo, this.props.setUserPrivileges);
  }

  getInfo = () => {
    document.getElementById("dtpReviseDate")?.focus();
  };

  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  reviseAMC = () => {
    if (!this.state.formData.dtpReviseDate) {
      this.props.toastErrorMsg("Select Revise AMC Date", "dtpReviseDate");
      return;
    }
    this.props.toastMsg("success", "AMC Revised Successfully");
  };

  render() {
    return (
      <form>
        {/* <Breadcrumbs aria-label="breadcrumb">
          <Link underline="hover" color="inherit" href="#/Dashboard">
            Dashboard
          </Link>
          <Link underline="hover" color="inherit" href="#/AMCDashboard">
            AMC Dashboard
          </Link>
          <Typography sx={{ color: "text.primary" }}>Revise AMC</Typography>
        </Breadcrumbs> */}

        <Grid container spacing={2} marginTop={2} alignItems={"center"}>
          <Grid item>
            <CtDtp
              id="dtpReviseDate"
              label="Revise AMC Date*"
              value={this.state.formData.dtpReviseDate}
              handleOnChange={this.handleOnChange}
              width={180}
            />
          </Grid>
          <Grid item>
            <CtBtn
              label="Revise"
              className="secondary-button"
              onClick={this.reviseAMC}
            />
          </Grid>
        </Grid>
      </form>
    );
  }
}

function WithNavigate(props) {
  const navigate = useNavigate();
  return <AMCRevise {...props} navigate={navigate} />;
}

export default connect(
  mapStatetoProps,
  mapSetUserPrivileges_ToProps,
)(HoCtToastContainer(HOCVerifyIsUser(withRouter(WithNavigate))));
